import { navigate } from 'gatsby';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import NullStateDiv from '@components/NullStateDiv';
import { ProcessStepper } from '@components/ProcessStepper/index';
import RecordCard from '@components/RecordCard';

import * as ROUTES from '@constants/routes';

import { useSession } from '@hooks/useSession';

import type { GeneticInformationObservationRecord } from '@models/genetic-information';

const messages = defineMessages({
  noRecordsFound: {
    id: 'informationList.noRecordsFound',
    defaultMessage: 'No Known Genetic {type} Records',
  },
});

function GeneticInformationList({
  data = [],
  type = '',
}: {
  data: GeneticInformationObservationRecord[];
  type: string;
}) {
  const { formatMessage } = useIntl();
  const {
    state: { isCurator },
  } = useSession();

  return data.length === 0 ? (
    <NullStateDiv>
      {formatMessage(messages.noRecordsFound, { type })}
    </NullStateDiv>
  ) : (
    <ProcessStepper
      allBlack
      stepNames={data.map((record) => (
        <RecordCard
          clickable={isCurator}
          key={record.id}
          onClick={() => {
            if (isCurator) {
              navigate(`${ROUTES.GENETIC_INFORMATION}${record.id}`);
            }
          }}
          recordSource={record.recordSource}
          selfReported={record.selfReported}
          status={record.curationStatus}
          text={record.value}
          viewed={record.viewedStatus}
        />
      ))}
    />
  );
}

export default GeneticInformationList;
